export default __webpack_public_path__ + "static/media/BrainBreak cards58.bb9651d0.png";